import React, { useEffect, useState, useContext, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import moment from 'moment';
import { AppContext } from "store/AppContext";
import { Button, Typography, Card, CardHeader, Divider, CardContent } from "@material-ui/core";
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { postKosningStyring, putKosningStyring, getOpnarKosningarInStyring, getVaentanlegarKosningar } from 'common/services/apiService';
import EnableKosningDialog from './components/EnableKosningDialog';
import DisableKosningDialog from './components/DisableKosningDialog';

const useStyles = makeStyles((theme) => ({
  titleSection: {
    textAlign: "left",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  titleText: {
    textTransform: "uppercase",
    borderBottom: "3px solid",
    borderBottomColor: theme.palette.primary.main,
  },
}));

const Admin = () => {
  const classes = useStyles();
  const context = useContext(AppContext);
  const [opnarKosningar, setOpnarKosningar] = useState([]);
  const [vaentanlegarKosningar, setVaentanlegarKosningar] = useState([]);
  const [selectedKosning, setSelectedKosning] = useState(null);
  const [enableKosningDialogOpen, setEnableKosningDialogOpen] = useState(false);
  const [disableKosningDialogOpen, setDisableKosningDialogOpen] = useState(false);

  const fetchOpnarKosningar = useCallback(async () => {
    const { data, isSuccess, error } = await getOpnarKosningarInStyring(context, []);

    if (isSuccess) {
      setOpnarKosningar(data);
    } else {
      console.error(error);
    }
  }, [context]);

  const fetchVaentanlegarKosningar = useCallback(async () => {
    const { data, isSuccess, error } = await getVaentanlegarKosningar(context, []);

    if (isSuccess) {
      setVaentanlegarKosningar(data);
    } else {
      console.error(error);
    }
  }, [context]);

  useEffect(() => {
    fetchOpnarKosningar();
    fetchVaentanlegarKosningar();
  }, [fetchOpnarKosningar, fetchVaentanlegarKosningar]);

  const refreshData = () => {
    fetchOpnarKosningar();
    fetchVaentanlegarKosningar();
  }

  const handleEnableKosning = async () => {
    const payload = {
      kosningId: selectedKosning.id,
      opin: true
    };
    
    const { isSuccess, error } = await postKosningStyring(
      payload,
      context,
      {}
    );

    if (isSuccess) {
      refreshData();
      setEnableKosningDialogOpen(false);
    } else {
      console.log(error);
    }
  };

  const handleDisableKosning = async () => {
    const payload = {
      kosningId: selectedKosning.id,
      opin: false
    };

    const { isSuccess, error } = await putKosningStyring(
      selectedKosning.id,
      payload,
      context
    );

    if (isSuccess) {
      refreshData();
      setDisableKosningDialogOpen(false);
    } else {
      console.log(error);
    }
  };

  const handleOpenEnableKosningDialog = (kosning) => {
    setSelectedKosning(kosning);
    setEnableKosningDialogOpen(true);
  };

  const handleOpenDisableKosningDialog = (kosning) => {
    setSelectedKosning(kosning);
    setDisableKosningDialogOpen(true);
  };

  return (
    <div>
      <Typography className={classes.titleSection} variant="h5" component="h2">
        <strong className={classes.titleText}>Stýring kosninga</strong>
      </Typography>
      <div>
        <Card style={{ marginTop: "16px" }}>
          <CardHeader title={"Opnar kosningar"} />
          <Divider />
          <CardContent>
            {opnarKosningar[0] ? (

            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Id</TableCell>
                  <TableCell>Kosning</TableCell>
                  <TableCell>Kjörskrárdagur</TableCell>
                  <TableCell>Kosningadagur</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {opnarKosningar.map((o) => (
                  <TableRow key={o.id}>
                    <TableCell>
                      <Button variant="outlined" color="secondary" size="small" onClick={() => handleOpenDisableKosningDialog(o)}>Loka</Button>
                    </TableCell>
                    <TableCell>{o.id}</TableCell>
                    <TableCell>{o.lysing}</TableCell>
                    <TableCell>{moment(o.kjorskrardagur).format("DD.MM.YYYY HH:mm")}</TableCell>
                    <TableCell>{moment(o.kosningadagur).format("DD.MM.YYYY HH:mm")}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            ) : (
              <Typography>Engar opnar kosningar</Typography>
            )}
          </CardContent>
        </Card>
      </div>
      <div>
        <Card style={{ marginTop: "16px" }}>
          <CardHeader title={"Væntanlegar kosningar"} />
          <Divider />
          <CardContent>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Id</TableCell>
                  <TableCell>Kosning</TableCell>
                  <TableCell>Kjörskrárdagur</TableCell>
                  <TableCell>Kosningadagur</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {vaentanlegarKosningar
                  .filter(v => !opnarKosningar.find(o => o.id === v.id))
                  .map((v) => (
                  <TableRow key={v.id}>
                    <TableCell>
                      <Button variant="outlined" color="primary" size="small" onClick={() => handleOpenEnableKosningDialog(v)}>Opna</Button>
                    </TableCell>
                    <TableCell>{v.id}</TableCell>
                    <TableCell>{v.lysing}</TableCell>
                    <TableCell>{moment(v.kjorskrardagur).format("DD.MM.YYYY HH:mm")}</TableCell>
                    <TableCell>{moment(v.kosningadagur).format("DD.MM.YYYY HH:mm")}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
      <EnableKosningDialog
        dialogOpen={enableKosningDialogOpen}
        setDialogOpen={setEnableKosningDialogOpen}
        selectedKosning={selectedKosning}
        handleEnableKosning={handleEnableKosning}
      />
      <DisableKosningDialog
        dialogOpen={disableKosningDialogOpen}
        setDialogOpen={setDisableKosningDialogOpen}
        selectedKosning={selectedKosning}
        handleDisableKosning={handleDisableKosning}
      />
    </div>
  );
}

export default Admin;